import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Button, Icon, IconButton, Modal } from '../modules';
import CartService from '../../services/CartService';
import CountryService from '../../services/CountryService';
import GoogleTagManagerService from '../../services/GoogleTagManagerService';

interface IBuyButtonProps extends RouteComponentProps {
  product: GQL.IProduct;
  variant: GQL.IProductVariant;
  mode?: 'simple' | undefined;
  quantity?: number | undefined;
  disabled?: boolean;
  onChange?: (quantity: number) => void;
  productLink?: string;
  GTMItemListName?: string;
}

interface IBuyButtonState {
  stockItem: any;
  showModal: boolean;
}

class BuyButton extends React.Component<IBuyButtonProps, IBuyButtonState> {
  constructor(props: IBuyButtonProps) {
    super(props);

    this.state = {
      stockItem: CartService.GetInstance().findVariant(this.props.variant.id),
      showModal: false,
    };

    this.addToCart = this.addToCart.bind(this);
    this.updateInCart = this.updateInCart.bind(this);
    this.updateSimpleCount = this.updateSimpleCount.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  public render() {
    const { language } = CountryService.GetInstance();
    const { mode, quantity } = this.props;
    const { stockItem } = this.state;

    if (mode === 'simple') {
      return (
        <div className="buy-button simple cf">
          <Button className="cart-minus" onClick={() => this.updateSimpleCount(-1)}>
            -
          </Button>
          <span>{quantity}</span>
          <Button className="cart-plus" onClick={() => this.updateSimpleCount(1)}>
            +
          </Button>
        </div>
      );
    }

    if (stockItem) {
      return (
        <div className="buy-button cf">
          <Button className="cart-minus" onClick={() => this.updateInCart(-1)}>
            -
          </Button>
          <span>{stockItem.quantity}</span>
          <Button className="cart-plus" onClick={() => this.updateInCart(1)}>
            +
          </Button>
          {this.state.showModal && (
            <div className="">
              <Modal
                type={'toCart'}
                language={language}
                variant={this.props.variant}
                onClose={this.closeModal}
                open={this.state.showModal}
                quantity={stockItem.quantity}
              />
            </div>
          )}
        </div>
      );
    }

    return (
      // <div className="buy-button cf">
      //   <Button className="buy" type="trans" size="sm" onClick={this.addToCart}>
      //     <Icon type="buy" />
      //   </Button>
      // </div>
      <div className="buy-button cf">
        <IconButton className="btn--buy" type="secondary" icon="cart" onClick={this.addToCart}>
          Buy
        </IconButton>
      </div>
    );
  }

  public closeModal() {
    this.setState({ showModal: false });
  }

  private async addToCart() {
    if (
      Array.isArray(this.props.product.variants)
      // nestačí this.props.product.variants.length > 1, protože variant selector se může zobrazovat i produktů s jednou variantou, pokud je u ní 'definition'
      && (this.props.product.variants.filter(v => v.definition && ('object' === typeof v.definition) && (Object.keys(v.definition).length > 0)).length > 0)
      && 'string' === typeof this.props.productLink
    ) {
      GoogleTagManagerService.clickProduct(this.props.variant);
      this.props.history.push(this.props.productLink);
      return;
    }
    const { variant } = this.props;

    this.setState({ showModal: true });
    await CartService.GetInstance().addToCart(variant, { GTMItemListName: this.props.GTMItemListName });

    this.updateStockItem();
  }

  private async updateInCart(count: number) {
    const { variant } = this.props;
    const { stockItem } = this.state;

    await CartService.GetInstance().updateQuantity(variant.id, stockItem ? stockItem.quantity + count : 1);

    this.updateStockItem();
  }

  private updateStockItem() {
    this.setState({
      stockItem: CartService.GetInstance().findVariant(this.props.variant.id),
    });
  }

  private updateSimpleCount(count: number) {
    if (this.props.quantity && this.props.onChange) {
      let newCount = this.props.quantity + count;
      if (newCount < 1) {
        newCount = 1;
      }

      this.props.onChange(newCount);
    }
  }
}

export default withRouter(BuyButton);



// WEBPACK FOOTER //
// ./src/modules/BuyButton/BuyButton.tsx